const validateUploadOptions = (options) => {
	if (typeof options !== "object" || options === null) {
		throw new Error("uploadFile: options is not an object");
	}
	if (!options.file || !options.path) {
		throw new Error("uploadFile: missing file or path attributes");
	}
	if (!options.metaData && options.public === undefined) {
		throw new Error("uploadFile: missing 'metaData' or 'public' attributes");
	}
	if (typeof options.metaData !== "object" && options.metaData !== undefined) {
		throw new Error("uploadFile: metaData is not an object");
	}
};
const handleUploadTask = (uploadTask, isPublic, pathStorageFileName, genFileName, resolve, reject) => {
	uploadTask.on(
		"state_changed",
		(snapshot) => {
			const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
			resolve(progress);
		},
		(error) => {
			console.error("uploadTask Error:", error);
			reject(error);
		},
		() => {
			if (isPublic) {
				uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
					resolve(createUploadData(downloadURL, pathStorageFileName, genFileName, uploadTask));
				});
			} else {
				resolve(createUploadData(null, pathStorageFileName, genFileName, uploadTask));
			}
		}
	);
};
const createUploadData = (downloadURL, pathStorageFileName, genFileName, uploadTask) => {
	return {
		downloadURL,
		bucketPath: pathStorageFileName,
		generatedName: genFileName,
		company_id: window.localStorage.getItem("company_id") || null,
		fileRef: uploadTask.snapshot.ref,
	};
};
export {validateUploadOptions, handleUploadTask};
